// Em qual trilho cada operação da API existe. A fonte é o `x-rails` de cada rota
// do packages/sdk/openapi.yaml: o vite.config lê a spec no build (railsFromSpec) e
// entrega o mapa ao painel. Assim o Playground não oferece, num projeto oficial,
// uma operação que lá só responde 409 — e não há uma segunda lista para esquecer
// de atualizar.

export type Rail = 'unofficial' | 'official';

/** "POST /messages/text" → trilhos em que a operação existe. */
export type RailMap = Record<string, Rail[]>;

/**
 * Extrai o mapa da spec. Leitura por linhas, sem parser de YAML: a spec segue um
 * layout fixo (rota com 2 espaços, verbo com 4, x-rails com 6), e o teste
 * rails.test.ts confere que todas as operações foram encontradas.
 */
export function railsFromSpec(yaml: string): RailMap {
  const out: RailMap = {};
  let inPaths = false;
  let path = '';
  let method = '';
  for (const line of yaml.split('\n')) {
    if (/^paths:\s*$/.test(line)) { inPaths = true; continue; }
    if (!inPaths) continue;
    if (/^\S/.test(line)) break; // fim do bloco paths
    let m = /^ {2}(\/\S*):\s*$/.exec(line);
    if (m) { path = m[1]; method = ''; continue; }
    m = /^ {4}(get|post|patch|put|delete):\s*$/.exec(line);
    if (m) { method = m[1].toUpperCase(); continue; }
    m = /^ {6}x-rails:\s*\[([^\]]*)\]/.exec(line);
    if (m && path && method) {
      out[`${method} ${path}`] = m[1].split(',').map((s) => s.trim()).filter(Boolean) as Rail[];
    }
  }
  return out;
}

/** A operação existe no trilho? Sem informação, não esconde (falha aberta). */
export function availableOn(map: RailMap, method: string, path: string, rail: Rail): boolean {
  const rails = map[`${method} ${path}`];
  return !rails || rails.includes(rail);
}
